import { useCallback, useMemo } from 'react';
import { useDoc, useLiberacao } from '../store/store';
import { feriadosDoAno, feriadosDoDia, prefPadrao, type FeriadosPref } from '../lib/feriados';
import { useVersaoFeriados } from '../lib/feriadosMundo';
import { paisAparelho } from '../lib/moeda';

/** Preferências de feriados do usuário. Sem escolha salva, usa Brasil + o que foi liberado pelo CPF. */
export function useFeriadosPref(): FeriadosPref {
  const aj = useDoc('ajustes');
  const lib = useLiberacao();
  return useMemo(() => {
    const p = aj.feriados ?? prefPadrao(lib.calendarios, lib.ilimitado, paisAparelho());
    const paises = p.paises.length ? p.paises : ['BR'];
    return { paises, regioes: p.regioes ?? {}, semNacionais: !!p.semNacionais };
  }, [aj.feriados, lib.calendarios, lib.ilimitado]);
}

/** Feriados dos países e regiões escolhidos em Ajustes > Visualizar feriados. */
export function useFeriados() {
  const pref = useFeriadosPref();
  const v = useVersaoFeriados();
  const doDia = useCallback((data: string) => feriadosDoDia(data, pref, v), [pref, v]);
  const doAno = useCallback((ano: number) => feriadosDoAno(ano, pref, v), [pref, v]);
  return { pref, paises: pref.paises, doDia, doAno };
}
